import { render, staticRenderFns } from "./AuthorTab.vue?vue&type=template&id=56813a6a&"
import script from "./AuthorTab.vue?vue&type=script&lang=js&"
export * from "./AuthorTab.vue?vue&type=script&lang=js&"
import style0 from "./AuthorTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports